import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  return <section className="w-full bg-ivory py-10 sm:py-12" aria-labelledby="guarantee-heading" data-id="element-110" data-mp="9ucpp2an3d0j">
      <div className="mx-auto max-w-3xl px-6" data-id="element-111" data-mp="9wpenzetenn3">
        <div className="rounded-4xl border border-line bg-shell px-7 py-10 text-center shadow-soft sm:px-12" data-id="element-112" data-mp="euh5sr7my5q8">
          <Medallion icon={ShieldCheckIcon} data-id="element-113" data-mp="jrr30t19nlom" />

          <p className="eyebrow mt-6 text-terracotta-deep" data-id="element-114" data-mp="nu4ablvnvrni">
            Your investment is 100% protected
          </p>
          <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-display text-[1.75rem] leading-[1.15] text-ink sm:text-4xl" data-id="element-115" data-mp="skcdzmynoo2w">
            7-Day Guarantee, No Questions Asked
          </h2>

          <p className="mx-auto mt-6 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-116" data-mp="12jjx6qs2ncxx">
            You receive exactly what we show and promise on this page. If within
            7 days the content delivered doesn’t match the description here, you
            request your refund and we return{' '}
            <span className="font-medium text-ink" data-id="element-117" data-mp="20rsq8qlcbn5l">100% of your money</span>.
          </p>

          <p className="mx-auto mt-8 inline-flex items-center gap-2.5 rounded-full border border-gold/40 bg-gold-soft/40 px-5 py-2.5 font-sans text-[0.8rem] font-medium text-gold-ink" data-id="element-118" data-mp="1vszf34tj088l">
            Refund rate: less than 0.5%
          </p>

          <div className="mt-9" data-id="element-119" data-mp="2ohn67h0yhru2">
            <CtaButton variant="terracotta" data-id="element-120" data-mp="2jjll6qjyzify">
              Get the complete system now
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}